// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".lemon-messages__load {\n  display: none;\n}\n.lemon-editor {\n  background: #fff;\n}\n.lemon-editor::before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 2px;\n  background: #efefef;\n}", ""]);
// Exports
module.exports = exports;
